import React from 'react'
import PropTypes from 'prop-types'
import { FaAngleRight, FaAngleLeft } from 'react-icons/fa'
import { NextSlide, PrevSlide } from './SliderElementsStyledComponents'

const NextArrow = ({ onClick, vertical }) => (
  <NextSlide
    onClick={onClick}
    vertical={vertical}
    type='button'
    data-role='none'
  >
    <FaAngleRight />
  </NextSlide>
)
const PrevArrow = ({ onClick, vertical }) => (
  <PrevSlide
    onClick={onClick}
    vertical={vertical}
    type='button'
    data-role='none'
  >
    <FaAngleLeft />
  </PrevSlide>
)

NextArrow.propTypes = PrevArrow.propTypes = {
  onClick: PropTypes.func,
  vertical: PropTypes.bool
}

export { NextArrow, PrevArrow }
